import { EDIT_LISTING_GUEST_ACCESS,
         CLOSE_LISTING_GUEST_ACCESS,
         PENDING_SUBMIT_LISTING_GUEST_ACCESS,
         COMPLETE_SUBMIT_LISTING_GUEST_ACCESS,
         FAILED_SUBMIT_LISTING_GUEST_ACCESS
    } from "./mlTypes"


const initialState = {
    pendingsubmit: false,
    failedsubmit: false,
    completesubmit: false,
    propertyguestaccessediting: false
}


const mlListingGuestAccessReducer = (state = initialState, action) => {
    switch (action.type) {
        case EDIT_LISTING_GUEST_ACCESS: return {
            ...state,
            pendingsubmit: false,
            failedsubmit: false,
            completesubmit: false,
            propertyguestaccessediting: true
        }

        case CLOSE_LISTING_GUEST_ACCESS: return {
            ...state,
            pendingsubmit: false,
            failedsubmit: false,
            completesubmit: false,
            propertyguestaccessediting: false
        }

        case PENDING_SUBMIT_LISTING_GUEST_ACCESS: return {
            ...state,
            pendingsubmit: true,
            failedsubmit: false,
            completesubmit: false
        }

        case COMPLETE_SUBMIT_LISTING_GUEST_ACCESS: return {
            ...state,
            pendingsubmit: false,
            failedsubmit: false,
            completesubmit: true
        }
        
        case FAILED_SUBMIT_LISTING_GUEST_ACCESS: return {
            ...state,
            pendingsubmit: false,
            failedsubmit: true,
            completesubmit: true
        }
    
        default: return state
    }
}

export default mlListingGuestAccessReducer